import { useEffect, useState } from 'react';
import useWindowSize from './useWindowSize';

const useMousePos = () => {
  const { W, H } = useWindowSize()
  const [pos, setPos] = useState({ x: W / 2, y: H / 2 });

  useEffect(() => {
    const handleMouseMove = (event) => {
      setPos({ x: event.clientX, y: event.clientY });
    };

    window.addEventListener('mousemove', handleMouseMove);

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
    };
  }, []);

  return {
    pos
  }
}

export default useMousePos;